<template lang="pug">
  v-dialog(v-model="show" max-width="500" scrollable :fullscreen="$vuetify.breakpoint.smAndDown" persistent)
    v-card
      v-card-title {{ $t('settingsPage.offerStructure.sortGroupLabel') }}
      v-card-text.pb-0.overflow-auto(style="height: 400px")
        v-list(dense)
          draggable(
            ghost-class="grey"
            v-model="menuGroupItemList"
            @change="onDraggableChange")
            template(v-for="(item,idx) in menuGroupItemList")
              v-list-item.listItem.subtitle-1.elevation-1.mb-1
                v-icon.pr-4(small) fal fa-bars
                span {{item.order}}. {{item.title}}
      v-divider
      v-card-actions
        v-row.ma-0
          v-col.text-end(cols="12")
            v-btn.text-end( color="primary" text @click="onCancelButtonClick" :disabled="loading" ) {{ $t('optOutDialog.cancelButtonLabel') }}
            v-btn.text-end(color="primary" :loading="loading" @click="onSubmitButtonClick") {{$t('optOutDialog.submitCreditButtonLabel') }}

</template>

<script lang="ts">

import {Component, Prop} from "vue-property-decorator";
import Vue from 'vue';
import draggable from 'vuedraggable'
import MenuGroupList from "@/model/menu/MenuGroupList";


@Component({
  components: {
    draggable
  }
})

export default class GroupSortingDialog extends Vue {

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean
  @Prop({ type: Array, default: false }) readonly menuGroupItem!: MenuGroupList[]

  private menuGroupItemList: MenuGroupList[] = []



  onSubmitButtonClick (): void {
    this.$emit('updateMenuGroupOrder', this.menuGroupItemList)
  }

  onCancelButtonClick (): void {
    this.$emit('close')
  }

  onDraggableChange (item: MenuGroupList): void {
    this.menuGroupItemList = this.menuGroupItemList.map((i: MenuGroupList, idx: number) => {
      return i.updateOrder(idx+1)
    })
  }

  mounted() {
    this.menuGroupItemList = this.menuGroupItem
  }
}

</script>

<style lang="stylus" scoped>
.listItem {
  cursor pointer
}
</style>
